const TaskCard = ({ task, isEditable = false, onStatusChange }) => {
  return (
    <div className="task-card">
      <div className="task-card-header">
        <h4>{task.title}</h4>
        <span className={`status-pill ${task.status.replace(" ", "-")}`}>
          {task.status}
        </span>
      </div>
      <p>{task.description}</p>
      <div className="task-meta">
        <span>Trainer ID: {task.trainerId}</span>
        <span>Trainee ID: {task.traineeId}</span>
      </div>
      {isEditable && (
        <div className="task-actions">
          <label htmlFor={`status-${task.id}`}>Update status</label>
          <select
            id={`status-${task.id}`}
            value={task.status}
            onChange={(event) => onStatusChange(task.id, event.target.value)}
          >
            <option value="Pending">Pending</option>
            <option value="In Progress">In Progress</option>
            <option value="Completed">Completed</option>
          </select>
        </div>
      )}
    </div>
  );
};

export default TaskCard;
